
<div>
    <div class="row">
      <div class="col-md-4 offset-md-4 border shadow p-3 mb-5 rounded-lg">
            <form  [formGroup]="emailForm" (ngSubmit)="retrieve()" *ngIf="!token && !mailSent"> 
                <h3>Recover my password</h3>    
                <div class="form-group">
                <mat-form-field>
                    <mat-label>Email</mat-label> 
                    <input matInput [formControl]="formEmail.email" [errorStateMatcher]="matcher"
                        placeholder="Ex. pat@example.com">
                    <mat-error *ngIf="formEmail.email.hasError('email') && !formEmail.email.hasError('required')">
                    Please enter a valid email address
                    </mat-error>
                    <mat-error *ngIf="formEmail.email.hasError('required')">
                    Email is <strong>required</strong>
                    </mat-error>
                </mat-form-field>
                </div>
                <div class="text-right">
                    <mat-spinner diameter="30" *ngIf='loading'></mat-spinner>
                    <button mat-raised-button type="submit" color="accent">Submit</button>
                </div>
            </form>
            <form *ngIf="!token && mailSent"> 
              <h3>An email has been sent</h3>    
            </form>
            <form  [formGroup]="passwordForm" (ngSubmit)="changePwd()" *ngIf="token && !errorPwd"> 
                <h3>New password</h3>    
                <div class="form-group">
                    <mat-form-field>
                      <mat-label>Password</mat-label> 
                      <input matInput type="password" [formControl]="formPwd.password" [errorStateMatcher]="matcher" placeholder="Password">
                      <mat-error *ngIf="formPwd.password.hasError('minlength') && !formPwd.password.hasError('required')">
                        Minimum 6 caracters
                      </mat-error>
                      <mat-error *ngIf="formPwd.password.hasError('required')">
                        Password <strong>required</strong>
                      </mat-error>
                    </mat-form-field>
                  </div>
        
                  <div class="form-group">
                    <mat-form-field>
                      <mat-label>Password confirm</mat-label> 
                      <input matInput type="password" [formControl]="formPwd.passwordConfirm" [errorStateMatcher]="matcher"
                            placeholder="password Confirm">
                      <mat-error *ngIf="formPwd.passwordConfirm.hasError('mustMatch')">
                        Passwords must match
                      </mat-error>
                    </mat-form-field>
                  </div>
                  
                <div class="text-right">
                    <mat-spinner diameter="30" *ngIf='loading'></mat-spinner>
                    <button mat-raised-button type="submit" color="accent">Submit</button>
                </div>
            </form>
            <form *ngIf="token && errorPwd"> 
              <h3>An error occured, please restart the process to change your password.</h3>    
            </form>
        </div>
    </div>
</div>